import React from 'react'
import { useTranslation } from 'lib/i18n'
import { Refinement } from 'lib/Refinement/types'

import FilterTitle from 'components/UI/Filters/FilterTitle'
import FilterWrapper from 'components/UI/Filters/FilterWrapper'
import useAlgoliaIndices from 'hooks/useAlgoliaIndices'

import CustomSortBy from './CustomSortBy'

export const priceSortRefinement: Refinement = {
  getQueryParamValue: ({ sortBy }) => sortBy && { sortBy },
  getStateValue: ({ sortBy }) => sortBy && ({ sortBy } as { sortBy: string }),
}

const PriceSort = (): JSX.Element => {
  const { profilesIndex, profilesIndexPriceAsc, profilesIndexPriceDesc } =
    useAlgoliaIndices()
  const { t } = useTranslation()

  return (
    <FilterWrapper>
      <FilterTitle title={t('filter.sortBy.title', 'Sort by')} />
      <CustomSortBy
        defaultRefinement={profilesIndex}
        items={[
          {
            value: profilesIndexPriceDesc,
            label: t('filter.sortBy.priceDesc', 'Price: High Low'),
          },
          {
            value: profilesIndexPriceAsc,
            label: t('filter.sortBy.priceAsc', 'Price: Low High'),
          },
        ]}
      />
    </FilterWrapper>
  )
}

export default PriceSort
